import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { ResponsiveButtonUniDriver } from '../ResponsiveButton/ResponsiveButton.uni.driver';

export function MultiLevelSortingCTAButtonUniDriver(
  base: UniDriver,
  body: UniDriver,
  options: {
    dataHook: string;
  },
) {
  return {
    ...ResponsiveButtonUniDriver(base, body, options),
  };
}
